import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";
import DiagnosisCodeHcc from './DiagnosisCodeHcc'

export interface DiagnosisListProps {
    diagnosisCodes: APIStore.PatientDiagnosis[],
    listLabel: string
}


const DiagnosisList = (props : DiagnosisListProps) => {
    let { diagnosisCodes, listLabel } = props;

    if (!diagnosisCodes || !diagnosisCodes.length) {
        return (<></>)
    }

    return (
        <>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>{listLabel}:</strong>
            </Typography>
            {
                diagnosisCodes.map(val => {
                    if(val.diagnosis.isRiskAdjusted) {
                        return <DiagnosisCodeHcc dxCode = {val}></DiagnosisCodeHcc>
                    }
                    if(val.shortDescription) {
                        return (
                            <Typography variant="body2" component="p" gutterBottom>
                                {val.diagnosis.diagnosisCodeValue} - {val.shortDescription}
                            </Typography>)
                    } else {
                        return (
                            <Typography variant="body2" component="p" gutterBottom>
                                {val.diagnosis.diagnosisCodeValue}
                            </Typography>)
                    }
                 
                })
            }
        </>
    );
}

export default DiagnosisList;
